import httpService from "./http.service";

export const getStatistics = async ({ filter, mode }) => {
  return httpService.apiRequest("post", "/api/statistics", {
    mode: mode,
    data: filter,
  });
};
